<template>
  <div class="min-h-screen bg-base-200 flex items-center justify-center">
    <div class="w-full max-w-md bg-base-100 shadow-xl rounded-lg p-6">
      <h2 class="text-2xl font-bold text-center mb-6 text-black">Admin Login</h2>
      <form @submit.prevent="handleLogin" class="space-y-4">
        <div class="form-control">
          <label class="label">
            <span class="label-text text-black">Username</span>
          </label>
          <input 
            type="text" 
            v-model="username"
            class="input input-bordered text-black bg-white"
            required
          />
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text text-black">Password</span>
          </label>
          <input 
            type="password" 
            v-model="password"
            class="input input-bordered text-black bg-white"
            required
          />
        </div>
        <button 
          type="submit" 
          class="btn btn-primary w-full"
          :disabled="isLoading"
        >
          <span v-if="isLoading">
            <span class="loading loading-spinner loading-sm"></span>
            Logging in...
          </span>
          <span v-else>Login</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const username = ref('')
const password = ref('')
const isLoading = ref(false)

const handleLogin = async () => {
  isLoading.value = true
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/api/admin/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        username: username.value,
        password: password.value 
      })
    })

    const data = await response.json()

    if (response.ok) {
      localStorage.setItem('adminToken', data.token)
      router.push('/admin/dashboard')
    } else {
      alert(data.message || 'Login failed')
    }
  } catch (error) {
    console.error('Login error:', error)
    alert('Failed to login')
  } finally {
    isLoading.value = false
  }
}
</script>

<style scoped>
/* Force black text color for inputs */
.input {
  color: black !important;
  background-color: white !important;
}

/* Style for input placeholder */
.input::placeholder {
  color: #6b7280 !important;
}

/* Force black text for labels */
.label-text {
  color: black !important;
}

.bg-base-100 {
  background-color: white !important;
}
</style> 